import { Badge } from '@/components/ui/Badge';
import type { FcRun } from '@/services/FlightCostService';

const MAP: Record<FcRun['status'], { label: string; variant: 'secondary' | 'warning' | 'success' | 'error' | 'outline' }> = {
  queued: { label: 'Queued', variant: 'secondary' },
  running: { label: 'Pricing…', variant: 'warning' },
  completed: { label: 'Priced', variant: 'success' },
  failed: { label: 'Failed', variant: 'error' },
  cancelled: { label: 'Cancelled', variant: 'outline' },
};

export function RunStatusBadge({ status }: { status: FcRun['status'] }) {
  const m = MAP[status] || MAP.queued;
  return <Badge variant={m.variant} className="text-[10px]">{m.label}</Badge>;
}
